// frontend/src/components/Footer/Footer.js

import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="border-t border-slate-200/80 bg-white font-sans">
      <div className="max-w-5xl mx-auto px-6 py-12">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          {/* Brand */}
          <div className="flex items-center gap-3 font-extrabold text-lg text-slate-900 tracking-tight">
            <span>CommitFlow</span>
          </div>

          {/* Links */}
          <div className="flex flex-wrap items-center gap-6 md:gap-8">
            <Link to="/" className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors">Inicio</Link>
            <Link to="/quienes-somos" className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors">Nosotros</Link>
            <Link to="/contacto" className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors">Contacto</Link>
            <Link to="/login" className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors">Acceder</Link>
          </div>
        </div>
        
        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-slate-100 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-slate-400">
            © 2025 CommitFlow. Todos los derechos reservados.
          </p>
          <span className="text-xs text-slate-400 font-medium bg-slate-100 px-3 py-1 rounded-full border border-slate-200/60">
            Plataforma de Gestión de Proyectos
          </span>
        </div>
      </div>
    </footer>
  );
}